import {API_DATE_FORMAT, DATE_FORMAT, TIME_FORMAT, TIME_FORMAT_ULTIMATE} from '@shared/constants/formats.constants';
import * as moment from 'moment';

/**
 * Define date.
 * @param {string} date
 * @returns {string}
 */
export const defineDate = (date: string): string =>
	date ? moment(date, API_DATE_FORMAT).format(DATE_FORMAT) : undefined;

/**
 * Define u t c date.
 * @param {string} date
 * @returns {Date}
 */
export const defineUTCDate = (date: string): Date => (date ? moment.utc(date, API_DATE_FORMAT).toDate() : undefined);

/**
 * Define time.
 * @param {string} date
 * @returns {string}
 */
export const defineTime = (date: string): string =>
	date ? moment(date, API_DATE_FORMAT).format(TIME_FORMAT) : undefined;

/**
 * Define time by seconds.
 * @param {number} date
 * @returns {string}
 */
export const defineTimeBySeconds = (date: number): string =>
	date ? moment.utc(date).format(TIME_FORMAT_ULTIMATE) : undefined;

/**
 * Random date.
 * @param {Date} start
 * @param {Date} end
 * @returns {string}
 */
export const randomDate = (start: Date, end: Date): string => {
	const temp = new Date(start.getTime() + Math.random() * (end.getTime() - start.getTime()));
	return moment(temp).format(DATE_FORMAT);
};
